module.exports = __webpack_public_path__ + "static/img/181221-bdnf-eq.217ae8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/181221-bdnf-eq.jpg
// module id = weMX
// module chunks = 0